import apiClient from "../../services/apiClient";
import {useMutation} from '@tanstack/react-query';

const useRequestPrice = ({onSuccess = () => {}, onError = () => {}}) => {
    return useMutation({
        mutationFn: (data) =>
            apiClient
                .post('requests/price', data)
                .then(res => res.data)
        ,
        onSuccess: (data) => {
            onSuccess(data);
        },
        onError: (error) => {
            onError({
                errors: error.message
            });
        }
    });
};

export default useRequestPrice;